import {defineStore} from "pinia";
import {ref} from "vue";

export const useFormatStore = defineStore("format", () => {

    const currency = ref({
        'symbol': '€',
        'label': '€',
        'value': 'euro',
        'code': 'EUR',
        'rate': 1.0000000
    })
    
    function formatPrice(price: number): string {
        const formatted = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price);

        return `€${formatted}`;
    }

    function formatNumber(amount) {
        if (!amount) return '0.00';
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }

    function formatCurrencyNumeric(amount, round=true) {
        if (!amount) return 0;
        let exchangedRate = Number(amount) * currency.value.rate;
        if(round){
            exchangedRate = Math.floor(exchangedRate/10) * 10;
        }
        return exchangedRate;
    }
    
    return{
        formatPrice,
        formatNumber,
        formatCurrencyNumeric
    }

})
